import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {GuidStrValue, SessionResponse, SessionRequest_Create, ImoTermDto} from 'webcommon/shared';
import { PrmHttpClientService } from '../PrmHttpClientService';

@Injectable({
  providedIn: 'root',
})
export class TerminologyRepository {
  constructor(
    private httpClientService: PrmHttpClientService,
  ) { }

  createSession(session: SessionRequest_Create): Observable<SessionResponse> {
    const endpointUrl = `terminology/sessions`;
    return this.httpClientService.sendPostRequest(endpointUrl, session);
  }

  getSessionTerms(sessionToken: GuidStrValue): Observable<ImoTermDto[]> {
    const endpointUrl = `terminology/sessions/${sessionToken}/terms`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }
}
